if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();


      /*Start GWP Code*/
      let btnProduct =  $(this)
      let qtyProducts=0
      let gwpProducts=0
       $.each($(`.promoproducts`), function(){

        let  gwpCollection = $(btnProduct).find('[data-promo]').attr('data-promo')
        let  gwpProduct = "," + $(this).attr('data-product')
        let  gwpProductType = $(this).attr('data-product-type')

        $.each($(`cart-remove-button`), function(){
          if (($(this).attr("data-product-type") == gwpProductType)){
            qtyProducts++;
          }
        })             

        if (qtyProducts == 0){
          if(gwpCollection.indexOf(gwpProduct)>=0){
               gwpProducts++;
          }
        }
      })
      /*End GWP Code*/   

      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            
            /*Start GWP Code*/
            var checkoutButton = document.getElementById('CartDrawer-Checkout');
            checkoutButton.disabled = true;
            checkoutButton.style.backgroundColor = '#c7c1c1';
            checkoutButton.style.color = '#c7c1c1';
            checkoutButton.querySelector('.loading-overlay-checkout').classList.remove('hidden');
            if(gwpProducts == 0 && qtyProducts >= 0){
             checkoutButton.disabled = false;
             checkoutButton.style.backgroundColor = '#000';
             checkoutButton.querySelector('.loading-overlay-checkout').classList.add('hidden');
            checkoutButton.style.color = '#fff';
            } 
            /*End GWP Code*/
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');


          //debugger
          /*let ele = this
          setTimeout(function(){
              addInkToBag(ele)
          },2000)
          
          if (this.submitButton.getAttribute('data-promo') === '0') return;
          setTimeout(function(){
            if($("#promoproducts").length > 0){
                      addToBag(ele)
             }              
          },1000)*/


          let btnProduct =  $(this)
          let sec = 700;
          $.each($(`.promoproducts`), function(){

            //debugger
            let qty=0
            let  gwpCollection = $(btnProduct).find('[data-promo]').attr('data-promo')
            let  gwpProduct = "," + $(this).attr('data-product')
            let  gwpProductType = $(this).attr('data-product-type')
            let  btnProductSubmit = $(this).find('[data-promo][type="submit"]');
            $.each($(`cart-remove-button`), function(){
              if (($(this).attr("data-product-type") == gwpProductType)){
                qty++;
              }
            })             

            if (qty == 0){
              //console.log(gwpProduct)
              //console.log(gwpCollection)
              if(gwpCollection.indexOf(gwpProduct)>=0){
                //console.log($(this).attr("data-product"))
                setTimeout(function(){
                   $(btnProductSubmit).click() 
                   //console.log("submit")
                }, sec)
                sec = sec + 700;
              }
            }
          })
                    
          
          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


const  addToBag = (elem) => {

    //debugger
    console.log("****************1")
    let qty = 0
    let removegwp
  //debugger
    $.each($(`cart-remove-button`), function(){
      if (($(this).attr("data-product-type") == "ultra.upgrade.v1")){
        removegwp = $(this)
        qty++;
      }
    }) 

    /*let myfk = document.querySelectorAll('[class^="remove-btn-MYFK"]').length;
    let prod = document.querySelectorAll('cart-remove-button').length;
    if ((myfk == 4) && (prod == 0)){
       $(removegwp).click()
    }*/

    //debugger
    if(qty>=1){
      return false
    } 

    $("#btn_gwp").click()
    return false;


    /*let itemsArray = []
    let itemsObj = {}

    item = {};
    item.id = 41279522144315
    item.quantity =parseInt(1); 
    itemsArray.push(item)
    
  
    itemsObj = {
      items : itemsArray
    }

   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      credentials: 'same-origin',
      dataType: 'json',
      data: itemsObj,
      async:false,
      success: function(response){
        console.log(response);
        //elem.cart.renderContents(response);
        //renderBag(response)
      },
       error: function(XMLHttpRequest, textStatus, errorThrown) {
         console.log(XMLHttpRequest.responseText, textStatus, errorThrown)
         //renderBag()
       }
    });*/

}  



const  addInkToBag = (elem) => {

    //debugger
    console.log("****************2")
    let qty = 0
    let removegwp

    $.each($(`cart-remove-button`), function(){
      if (($(this).attr("data-product-type") == "gwp.ink.free")){
        removegwp = $(this)
        qty++;
      }
    }) 

    //debugger
    if(qty>=1){
      return false
    } 

    setTimeout(function(){
      $("#btn_gwp1").click()
    },1000)
    return false;

}


